import { CourseDetailsModel } from '../models/course_details_model';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';

export type GetCourseDetailsCommand = (courseNk: string, sectionId?: ISection['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getCourseDetailsCommand',
    ($http: ng.IHttpService, ngCourseDetailsModel: CourseDetailsModel, defineCommandORM: IDefineCommand): ICommand => {
      return defineCommandORM('getCourseDetailsCommand', (deferred, courseNk: string, sectionId?: ISection['id']) => {
        $http
          .get(`/reg/course/nk/${courseNk}/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngCourseDetailsModel.clear().write({
              course_detail: data,
              sectionUsedToFetchCourseDetails: sectionId
            });
            deferred.resolve();
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/commands/get_course_details_command.ts